/**
 * 字符串相关函数
 * @param {*} params
 * 第一个参数是事件抛出的参数，后续全是常量
 * @return {*}
 */

const concat = {
    fn: (str, ...strs) => `${str}`.concat(...strs),
    desc: '接收N个参数(str, str2 [, ...strN])，返回 str.concat(str2 [, ...strN])，即连接字符串',
};

const reverseConcat = {
    fn: (str, ...strs) => `${strs.reverse().join('')}${str}`,
    desc: '接收N个参数(str [, ...strN])，返回 strN.concat(strM, ...str)，即倒序连接字符串',
};

const includes = {
    fn: (str, searchString, position) => `${str}`.includes(searchString, position),
    desc: '接收3个参数(str, searchString [, position])，返回 str.includes(searchString [, position])',
};

const indexOf = {
    fn: (str, searchValue, fromIndex) => `${str}`.indexOf(searchValue, fromIndex),
    desc: '接收3个参数(str, searchValue[, fromIndex])，返回 str.indexOf(searchValue [, fromIndex])',
};

const lastIndexOf = {
    fn: (str, searchValue, fromIndex) => `${str}`.lastIndexOf(searchValue, fromIndex),
    desc: '接收3个参数(str, searchValue[, fromIndex])，返回 str.lastIndexOf(searchValue [, fromIndex])',
};

const substring = {
    fn: (str, indexStart, indexEnd) => `${str}`.substring(indexStart, indexEnd),
    desc: '接收3个参数(str, indexStart[, indexEnd])，返回 str.substring(indexStart [, indexEnd])',
};

const toLowerCase = {
    fn: str => `${str}`.toLowerCase(),
    desc: '接收1个参数(str)，返回 str.toLowerCase()',
};

const toUpperCase = {
    fn: str => `${str}`.toUpperCase(),
    desc: '接收1个参数(str)，返回 str.toUpperCase()',
};

const trim = {
    fn: str => `${str}`.trim(),
    desc: '接收1个参数(str)，返回 str.trim()',
};

export default {
    concat,
    reverseConcat,
    includes,
    indexOf,
    lastIndexOf,
    substring,
    toLowerCase,
    toUpperCase,
    trim,
};
